// globalRouter.js

let navigator:any;

const globalRouter = {
  setNavigator: (nav:any) => {
    navigator = nav;
  },
  navigate: (...args:any) => {
    if (navigator) {
      navigator(...args);
    } else {
      console.error("Navigator is not set");
      // Fallback so session-expired redirects still work.
      if (typeof window !== "undefined") {
        window.location.href = "/login";
      }
    }
  },
};

export default globalRouter;